// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type SocialFacebookIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from social-facebook.svg
 */
export default function SocialFacebookIcon(props: SocialFacebookIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="SocialFacebookIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M15.999 8.049c0-4.445-3.582-8.049-8-8.049S0 3.604 0 8.049C0 12.066 2.925 15.396 6.75 16v-5.624H4.717V8.049H6.75V6.276c0-2.018 1.195-3.132 3.022-3.132.875 0 1.79.157 1.79.157v1.981h-1.008c-.994 0-1.304.62-1.304 1.257v1.51h2.219l-.355 2.327H9.25V16c3.825-.604 6.75-3.934 6.75-7.951z"
          clip-rule="evenodd"
        />
      </g>
    </svg>
  );
}
